<template>
  <div>
    <div
      v-for="(product, cartItemIndex) in cart"
      :key="cartItemIndex">
      <div
        v-if="product.variation_name"
        class="cart__item">
        <div class="cart__item--product-container">
          <div class="product-thumbnail cart__item-image">
            <a>
              <img
                :src="parentImage(product.parentID)"
                :alt="parentImageAlt(product.parentID)">
            </a>
          </div>

          <div
            class="cart__item--product-name"
            data-title>
            <h4 v-if="parentName(product.parentID)">{{ parentName(product.parentID) }}</h4>
            <p>{{ product.variation_name }}</p>

            <div
              class="product-size"
              data-title="product-size">
              <div class="select-button-style">
                <div class="arrow-button"></div>
                <select
                  id="bed-size"
                  class
                  name="attribute_bed-size"
                  data-attribute_name="attribute_bed-size"
                  data-show_option_none="yes"
                  @change="changeSize(cartItemIndex, $event)"
                >
                  <option disabled>Select a Size</option>
                  <option
                    v-for="(variation, variationIndex) in variations(product.parentID)"
                    :selected="variation.variation_name === product.variation_name"
                    :key="variationIndex"
                    :value="JSON.stringify(variation)"
                  >{{ variation.variation_name }}-${{ variation.price }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="cart__item--product-details">
          <div
            class="product-price cart__item--price-column"
            data-title="Price"
          >${{ getToFixed(product.price) }}</div>

          <div
            class="cart__item--quantity"
            data-title="Quantity">
            <h5 class="cart__item--mobile-title">Quantity</h5>

            <div class="quantity quantity-counter">
              <span
                class="cart__quantity-counter-button quantity-decrease"
                @click="decrement(cartItemIndex, product.quantity)"
              ></span>

              <span
                class="quantity-input input-text qty text"
                inputmode="numeric"
              >{{ product.quantity }}</span>

              <span
                class="cart__quantity-counter-button quantity-increase"
                @click="increment(cartItemIndex)"
              ></span>
            </div>

            <div class="cart__delete-item">
              <span
                class="remove"
                title="Remove this item"
                data-product_id="10"
                data-product_sku
                @click="removeItem(cartItemIndex)"
              >Delete</span>
            </div>
          </div>

          <div
            class="product-subtotal cart__item--total"
            data-title="Total">
            <h5 class="cart__item--mobile-title">Total</h5>
            ${{ getToFixed(product.price * product.quantity) }}
          </div>
        </div>
      </div>

      <div
        v-else
        class="cart__item">
        <div class="cart__item--product-container">
          <div class="product-thumbnail cart__item-image">
            <a>
              <img
                :src="parentImage(product.parentID)"
                :alt="parentImageAlt(product.parentID)">
            </a>
          </div>

          <div
            class="cart__item--product-name"
            data-title>
            <h4>
              {{ product.product_name }}
              <span class="cart__mobile-price-display">-
                <span class="woocommerce-Price-amount amount">
                  <span class="woocommerce-Price-currencySymbol">$</span>
                  {{ product.price }}
                </span>
              </span>
            </h4>
            <p>{{ product.description }}</p>
            <div class="cart__delete-item-mobile">
              <span @click="removeItem(cartItemIndex)">Delete</span>
            </div>
          </div>
        </div>

        <div class="cart__item--product-details">
          <div
            class="product-price cart__item--price-column"
            data-title="Price"
          >${{ getToFixed(product.price) }}</div>

          <div
            class="cart__item--quantity"
            data-title="Quantity">
            <h5 class="cart__item--mobile-title">Quantity</h5>

            <div class="quantity quantity-counter">
              <span
                class="cart__quantity-counter-button quantity-decrease"
                @click="decrement(cartItemIndex, product.quantity)"
              ></span>

              <span
                class="quantity-input input-text qty text"
                inputmode="numeric"
              >{{ product.quantity }}</span>

              <span
                class="cart__quantity-counter-button quantity-increase"
                @click="increment(cartItemIndex)"
              ></span>
            </div>

            <div class="cart__delete-item no-show-mobile">
              <span
                class="remove"
                title="Remove this item"
                data-product_id="10"
                data-product_sku
                @click="removeItem(cartItemIndex)"
              >Delete</span>
            </div>
          </div>

          <div
            class="product-subtotal cart__item--total"
            data-title="Total">
            <h5 class="cart__item--mobile-title">Total</h5>
            ${{ getToFixed(product.price * product.quantity) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('cart', {
      cart: 'cart'
    })
  },
  methods: {
    parentImage (parentID) {
      return this.$store.getters['products/parentImage'](parentID).url
    },
    parentImageAlt (parentID) {
      return this.$store.getters['products/parentImage'](parentID).alt
    },
    parentName (parentID) {
      return this.$store.getters['products/parentName'](parentID)
    },
    variations (parentID) {
      return this.$store.getters['products/variations'](parentID)
    },
    increment (index) {
      this.$store.commit('cart/INCREMENT', index)
    },
    decrement (index, quantity) {
      // Validate input, if value is 0, delete
      if (quantity === 1) {
        this.$store.commit('cart/REMOVE_FROM_CART', index)
      } else {
        this.$store.commit('cart/DECREMENT', index)
      }
    },
    removeItem (index) {
      this.$store.commit('cart/REMOVE_FROM_CART', index)
    },
    changeSize (index, e) {
      const payload = { 'index': index, 'payload': JSON.parse(e.target.value) }
      this.$store.commit('cart/CHANGE_SIZE', payload)
    },
    getToFixed (price) {
      return parseFloat(price).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.cart {
  @include e("item") {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 18px 0;
    border-bottom: 1px solid #ccc;

    @media screen and (max-width: 620px) {
      flex-direction: column;
    }

    @include m("product-container") {
      width: 57%;
      display: flex;
      flex-direction: row;
      align-items: center;

      @media screen and (max-width: 830px) {
        flex-wrap: wrap;
      }

      @media screen and (max-width: 620px) {
        width: 100%;
        margin-bottom: 15px;
      }
    }

    @include m("product-details") {
      width: 43%;
      display: flex;
      flex-direction: row;

      @media screen and (max-width: 620px) {
        width: 100%;
        justify-content: space-between;
      }
    }

    @include m("price-column") {
      width: 39%;
      font-size: 18px;
      font-weight: bold;
      text-align: center;

      @media screen and (max-width: 1125px) {
        width: 34%;
      }

      @media screen and (max-width: 960px) {
        display: none;
      }
    }

    @include m("product-name") {
      @media screen and (min-width: 620px) {
        padding-right: 15px;
      }

      h4 {
        font-size: 21px;
        margin: 0 0 5px;
      }

      p {
        font-size: 18px;
        margin: 0;
      }

      @media screen and (max-width: 830px) {
        margin-bottom: 15px;
      }

      @media screen and (max-width: 620px) {
        width: 100%;
        margin-bottom: 0px;
      }
    }

    @include m("quantity") {
      width: 23%;

      @media screen and (max-width: 1125px) {
        width: 35%;
      }

      @media screen and (max-width: 960px) {
        width: 59%;
      }
    }

    @include m("total") {
      width: 35%;
      text-align: right;
      font-size: 18px;
      font-weight: bold;
    }

    @include m("mobile-title") {
      display: none;
      margin: 5px 0 15px 0;
      font-size: 18px;

      @media screen and (max-width: 620px) {
        display: block;
        font-size: 16px;
      }
    }
  }

  @include e("item-image") {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    margin-right: 20px;

    img {
      width: 100%;
      padding: 15px 15px 15px 0px;
    }

    @media screen and (max-width: 960px) {
      display: none;
    }
  }

  @include e(delete-item-mobile) {
    display: none;
    margin-top: 20px;

    a {
      color: #bbbbbb;
      font-size: 14px;
      font-weight: bold;
    }

    @media screen and (max-width: 460px) {
      display: block;
    }
  }

  @include e(delete-item) {
    padding: 15px 0 0;
    text-align: center;
    margin: 0;

    .remove {
      color: $grey;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
    }

    @media screen and (max-width: 620px) {
      padding: 15px 0 0 12px;
      text-align: left;
    }
  }
}

.product-size {
  padding-right: 25px;
  margin-top: 15px;

  @media screen and (max-width: 620px) {
    padding: 0;
    width: 100%;
    .select-button-style {
      max-width: 100%;
    }
  }
}
.select-button-style select {
  min-width: 200px;
  width: 100%;
}
.cart__item--product-name {
  p {
    font-size: 14px;
  }
}

.quantity-counter {
  margin: 0 auto;
  text-align: center;

  @media screen and (max-width: 620px) {
    margin: 0;
    text-align: left;
  }
}

.cart__quantity-counter-button {
  width: 25px;
  height: 25px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  vertical-align: middle;

  @media screen and (max-width: 850px) {
    padding: 4px;
  }
}

.quantity-decrease {
  background-image: url("/img/icon-minus.png");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.quantity-increase {
  background-image: url("/img/icon-plus.png");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.select-button-style {
  max-width: 420px;
}

.quantity-input {
  width: 30px;
  text-align: center;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 18px;
  display: inline-block;

  @media screen and (max-width: 460px) {
    width: 25px;
  }
}
</style>
